export interface CompanyStatusState {
    notEnoughActiveEmployees: boolean;
    notEnoughActiveEmployeesPrelaunch: boolean;
    noEmployees: boolean;
    noNames: boolean;
    hierarchiesNoMinimum: boolean;
    noAnnouncementsPrelaunch: boolean;
    noHierarchiesPrelaunch: boolean;
    statusResults: string[];
}

export const createDefaultState = (): CompanyStatusState => ({
    notEnoughActiveEmployees: false,
    notEnoughActiveEmployeesPrelaunch: false,
    noEmployees: false,
    noNames: false,
    hierarchiesNoMinimum: false,
    noAnnouncementsPrelaunch: false,
    noHierarchiesPrelaunch: false,
    statusResults: []
});

export const evaluateCompanyStatusResults = (results: string[] | null | undefined): CompanyStatusState => {
    if (!results || results.length === 0) {
        return createDefaultState();
    }

    return {
        notEnoughActiveEmployees: results.includes('NO_ENOUGH_ACTIVE_EMPLOYEES'),
        notEnoughActiveEmployeesPrelaunch: results.includes('NO_ENOUGH_ACTIVE_EMPLOYEES_PRELAUNCH'),
        noEmployees: results.includes('NO_EMPLOYEES'),
        noNames: results.includes('NO_ALL_EMPLOYEES_HAVE_NAMES'),
        hierarchiesNoMinimum: results.includes('HIERARCHIES_NO_MINIMUM'),
        noAnnouncementsPrelaunch: results.includes('NO_ANNOUNCEMENTS_PRELAUNCH'),
        noHierarchiesPrelaunch: results.includes('NO_HIERARCHIES_PRELAUNCH'),
        statusResults: results
    };
};
